<div class="card card-dark mb-0">
    <div class="card-header" *ngIf="showHeader">
        <h2 class="card-title">{{label}}</h2>
    </div>
    <div class="card-body p-0">
        <div class="table-responsive">
            <table class="table table-hover m-0">
                <thead>
                    <tr>
                        <th class="cursor-pointer">Movimiento</th>
                        <th class="cursor-pointer">Pedido</th>
                        <th class="cursor-pointer">Tipo Pago</th>
                        <th class="cursor-pointer">Fecha</th>
                        <th class="cursor-pointer">Hora</th>
                        <th class="cursor-pointer">Ingreso</th>
                        <th class="cursor-pointer">Egreso</th>
                        <th class="cursor-pointer">Acumulado</th>
                    </tr>
                </thead>
                <div class="progress-linear" *ngIf="isLoading">
                    <div class="container">
                        <div class="bar"></div>
                    </div>
                </div>
                <tbody *ngIf="!isLoading">
                    <tr *ngFor="let row of rows">
                        <td>
                            <span>{{row.movimiento}}
                                <app-popover [classIcon]="'fas fa-comment-dots ml-1'" [colorIcon]="'text-lightblue'"
                                    [message]="row.motivo" *ngIf="row.motivo"></app-popover></span>
                        </td>
                        <td>
                            <span>{{row.numero_pedido_format || row.id_pedido}}</span>
                        </td>
                        <td>
                            <span>{{row.tipopago}}</span>
                        </td>
                        <td>
                            <span>{{row.fecha_movimiento | date: 'dd/MM/yyyy'}}</span>
                        </td>
                        <td>
                            <span>{{row.hora_movimiento}}</span>
                        </td>
                        <td>
                            <span>{{row.ingreso}}</span>
                        </td>
                        <td>
                            <span>{{row.egreso}}</span>
                        </td>
                        <td>
                            <span>{{row.acumulativeTotal}}</span>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="5">Total:</td>
                        <td>{{ getColumnTotal('ingreso') }}</td>
                        <td>{{ getColumnTotal('egreso') }}</td>
                        <td>{{ getCumulativeTotal() }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</div>